import type { UnassignedUsers } from 'src/apis/authorization-service/types';
import { useAxios } from 'src/hooks/use-axios';

export function useUnassignAllUsersFromPermissionGroup() {
  return useAxios(
    (axios, baseConfig, url: string) =>
      axios.request<UnassignedUsers>({
        method: 'DELETE',
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: false }
  );
}

export type UnassignAllUsersFromPermissionGroup = ReturnType<
  typeof useUnassignAllUsersFromPermissionGroup
>;
